import { render, staticRenderFns } from "./qqqx.vue?vue&type=template&id=1e52e2ac&scoped=true&"
import script from "./qqqx.vue?vue&type=script&lang=js&"
export * from "./qqqx.vue?vue&type=script&lang=js&"
import style0 from "./qqqx.vue?vue&type=style&index=0&id=1e52e2ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52e2ac",
  null
  
)

export default component.exports